import styled, { css } from 'styled-components';
import { THEME } from '../../../../../../../themes';
import { ASSETS } from '../../../../../../../assets';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  gap: ${THEME.SPACING.TINO};
`;

export const MultipleExperienceContainer = styled.div`
  display: flex;
  gap: ${THEME.SPACING.BASE};
  flex-direction: column;
`;

const CompanyNameStyle = css`
  cursor: pointer;

  :hover {
    color: ${THEME.COLORS.PRIMARY_DARK};
    border-bottom: 2px ${THEME.COLORS.PRIMARY_DARK} dashed;
  }
`;

export const CompanyName = styled.span<{ disabled: boolean }>`
  ${({ disabled }) => {
    if (disabled) {
      return '';
    }
    
    return CompanyNameStyle;
  }};
`;

export const CompanyIcon = styled(ASSETS.INSIGHTS_PANEL_COMPONENT)`
  margin-left: ${THEME.SPACING.MICRO};
  fill: ${THEME.COLORS.ACCENT};
  width: 13px;
  height: 13px;
`;

export const PromotionBadgeWrapper = styled.div`
  margin-left: ${THEME.SPACING.MICRO};
`;
